export default (value) => {
    var nutritionBase = process.env.REACT_APP_NUTRITION_BASE;
    return parseInt(value/nutritionBase);
}